export enum SnackBarTheme {
    error = 'error',
    success = 'success',
    default = 'default'
}